import Vue from "vue";

export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/eventBus/nav-bar-event.js